import { render } from "./ImageCategoryDialog.vue?vue&type=template&id=0f93b3c6"
import script from "./ImageCategoryDialog.vue?vue&type=script&lang=ts"
export * from "./ImageCategoryDialog.vue?vue&type=script&lang=ts"

import "./ImageCategoryDialog.vue?vue&type=style&index=0&id=0f93b3c6&lang=scss"
script.render = render

export default script
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QBtn});
